/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsControllerFindTopProductsQueryResponse,
  TelegramProductsControllerFindTopProducts401,
} from '../../types/TelegramProductsControllerFindTopProducts.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsFindTopProducts } from '../../methods/telegramProductsFindTopProducts.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsFindTopProductsQueryKey = () => [{ url: '/api/telegram/products/top' }] as const;

export type TelegramProductsFindTopProductsQueryKey = ReturnType<typeof telegramProductsFindTopProductsQueryKey>;

export function telegramProductsFindTopProductsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsFindTopProductsQueryKey();
  return queryOptions<
    TelegramProductsControllerFindTopProductsQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindTopProducts401>,
    TelegramProductsControllerFindTopProductsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsFindTopProducts(config);
    },
  });
}

/**
 * {@link /api/telegram/products/top}
 */
export function useTelegramProductsFindTopProducts<
  TData = TelegramProductsControllerFindTopProductsQueryResponse,
  TQueryData = TelegramProductsControllerFindTopProductsQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsFindTopProductsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsControllerFindTopProductsQueryResponse,
        ResponseErrorConfig<TelegramProductsControllerFindTopProducts401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsFindTopProductsQueryKey();

  const query = useQuery(
    {
      ...telegramProductsFindTopProductsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsControllerFindTopProducts401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
